// extracted by mini-css-extract-plugin
module.exports = {"main":"TableList_main__1FhWl","header":"TableList_header__1Ft0T","container":"TableList_container__1bEcb","item":"TableList_item__20psI","actions":"TableList_actions__3QaxH"};